export const tagsData = [
  {
    name: 'Vegetarian',
    icon: 'icon-Leaf',
    green: true,
  },
  {
    name: 'Vegan',
    icon: 'icon-Broccoli',
    green: true,
  },
  {
    name: 'Spicy',
    icon: 'icon-Chili',
    green: false,
  },
  {
    name: 'Contains Alcohol',
    icon: 'icon-Wine-Glass',
    green: false,
  },
  {
    name: 'May Contain Bones and/or Shell',
    icon: 'icon-Bone',
    green: false,
  },
  {
    name: 'Greene King Brewery',
    icon: null,
    green: false,
  },
  {
    name: 'Morland Brewery',
    icon: null,
    green: false,
  },
  {
    name: 'Belhaven Brewery',
    icon: null,
    green: false,
  },
  {
    name: 'under 600 calories',
    icon: null,
    green: false,
    label: 'Under 600 kcal',
  },
];
